import $ from 'jquery';
import ProductItem from '../components/ProductItem';
import FacetedFiltering from '../components/FacetedFiltering';
import RTE from '../components/RTE';

export default class StaticCollection {
  constructor(section) {
    this.el = section.el;
    this.$sortBy = $('#sort-by', this.el);
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];
    this.filtersEnabled = this.el.querySelector('[data-faceted-filter]');

    if (this.filtersEnabled) {
      this.facetedFilters = new FacetedFiltering(this.el);
    }

    for (let i = 0; i < this.productEls.length; i++) {
      this.products.push(new ProductItem(this.productEls[i]));
    }

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }

    this.initSort();
  }

  sortDropDown(e) {
    Shopify.queryParams = {};

    if (location.search.length) {
      let aKeyValue;
      let i = 0;
      const aCouples = location.search.substr(1).split('&');

      while (i < aCouples.length) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
        i++;
      }
    }

    Shopify.queryParams.sort_by = $(e.currentTarget, this.el).val();
    location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
  }

  initSort() {
    const urlParam = new RegExp('[?&]sort_by=([^&#]*)').exec(window.location.href);
    if (urlParam && urlParam[1]) {
      this.$sortBy.val(urlParam[1]);
    }

    this.$sortBy.on('change.sorting', this.sortDropDown.bind(this));
  }


  onSectionUnload() {
    this.products.forEach(product => product.unload());
    this.rtes.forEach(rte => rte.unload());
    this.$sortBy.off('.sorting');
    if (this.facetedFilters) {
      this.facetedFilters.unload();
    }
  }
}
